module.exports = "../fonts/ApercuLAPhil-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./@fonts/apercu-laphil/ApercuLAPhil-Regular.woff
// module id = 506
// module chunks = 7